export default () => ({
    stories: [],
    brands: [],
    products: []
})